module.exports = __webpack_public_path__ + "img/oneIcon.d08f5625.jpg";